import * as main from './main'

const wt: any = {...main}
export {
  wt
}
